var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInTransitoBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 38",
    style: {
      enableBackground: "new 0 0 72 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M50.8,32.2H31.9c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h17.9V2.4H19.6c-0.5,0-1-0.4-1-1s0.4-1,1-1h31.2 c0.5,0,1,0.4,1,1v29.8C51.8,31.8,51.3,32.2,50.8,32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M21.1,32.2h-8.6c-0.5,0-1-0.4-1-1v-8.6c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1v7.6h7.6c0.5,0,1,0.4,1,1 C22.1,31.8,21.7,32.2,21.1,32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M55.6,32.2h-4.7c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h4.7c0.5,0,1,0.4,1,1C56.6,31.8,56.2,32.2,55.6,32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M70.2,32.2h-3.6c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1H70V17.1h-2.6c-0.4,0-0.7-0.2-0.9-0.5l-3.8-7.5H50.9 c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h12.4c0.4,0,0.7,0.2,0.9,0.5l3.8,7.5h2.2c1,0,1.8,0.8,1.8,1.8v13.4C72,31.4,71.2,32.2,70.2,32.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M60.6,38c-3.2,0-5.7-2.6-5.7-5.7c0-3.2,2.6-5.7,5.7-5.7c3.2,0,5.7,2.6,5.7,5.7C66.4,35.4,63.8,38,60.6,38z  M60.6,28.5c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8S62.7,28.5,60.6,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M26.2,38c-3.2,0-5.7-2.6-5.7-5.7c0-3.2,2.6-5.7,5.7-5.7c3.2,0,5.7,2.6,5.7,5.7C31.9,35.4,29.4,38,26.2,38z  M26.2,28.5c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8S28.3,28.5,26.2,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M21.6,7.4h-9.1c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h9.1c0.5,0,1,0.4,1,1S22.2,7.4,21.6,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M21.4,13.3H4.3c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h17.2c0.5,0,1,0.4,1,1C22.4,12.9,22,13.3,21.4,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M13.2,19.2H1c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h12.2c0.5,0,1,0.4,1,1C14.1,18.8,13.7,19.2,13.2,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M61.4,17.7h-6.1c-0.5,0-1-0.4-1-1v-4.5c0-0.5,0.4-1,1-1h4.4c0.4,0,0.8,0.3,0.9,0.6l1.7,4.5 c0.1,0.3,0.1,0.6-0.1,0.9C62,17.5,61.7,17.7,61.4,17.7z M56.3,15.7H60l-0.9-2.6h-2.8V15.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTransitoBlu);
export default __webpack_public_path__ + "static/media/inTransitoBlu.31717b3d.svg";
export { ForwardRef as ReactComponent };